import ExtendedApplicationState from "@husky-hrc/Framework/Store/ExtendedApplicationState";
import { getById } from "@insite/client-framework/Store/Data/DataState";

export function getExternalProvidersByUrl(state: ExtendedApplicationState, url?: string) {
    return getById(state.signIn, url);
}
